import React, { PropsWithChildren, useRef } from 'react';
import { ButtonProps } from '../../../../types/HtmlProps';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import Bem from '../../../../lib/bemUtils/bem';
import { AccordionToggleButtonModifier } from './Accordion.modifier';

interface AccordionToggleButtonProps extends ButtonProps {
  modifier?: AccordionToggleButtonModifier;
  ref?: React.RefObject<HTMLButtonElement | null>;
}

export function AccordionToggleButton({
  children,
  modifier,
  ref,
  ...buttonProps
}: PropsWithChildren<AccordionToggleButtonProps>) {
  return (
    <button ref={ref} {...buttonProps} className={Bem('accordion__button', modifier)} type="button">
      {children}
    </button>
  );
}

export function AccordionToggleButtonWithTooltip({
  children,
  tooltipPlacement,
  ...buttonProps
}: PropsWithChildren<
  {
    tooltipPlacement?: TooltipPlacement;
  } & ButtonProps
>) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  return (
    <Tooltip attachTo={buttonRef} placement={tooltipPlacement}>
      <AccordionToggleButton {...buttonProps} ref={buttonRef}>
        {children}
      </AccordionToggleButton>
    </Tooltip>
  );
}
